module.exports = __webpack_public_path__ + "img/task-clsss.b73d69de.png";